import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M40 42.953a3 3 0 0 1-5.103 2.14l-7.283-7.158c-1.148.02-2.296.03-3.444.03-5.045 0-10.157-.187-15.333-.56a7 7 0 0 1-6.47-6.362C2.122 28.288 2 25.273 2 22c0-2.64.08-4.955.24-6.946A7 7 0 0 1 8.72 8.63C14.64 8.21 19.755 8 24.066 8c4.3 0 9.371.21 15.218.628a7 7 0 0 1 6.477 6.422c.16 1.992.24 4.308.24 6.95 0 3.278-.123 6.297-.368 9.055A7.001 7.001 0 0 1 40 37.305v5.648Z",
    fill: "currentColor"
  }));
};

var SvgMessage = styled(SvgComponent).withConfig({
  displayName: "Message__SvgMessage",
  componentId: "sc-1wgt1e8-0"
})(["", " ", ""], size, color);
export default SvgMessage;